import React, { useReducer } from 'react'

import LiveNowContext from './LiveNowContext'

type LiveNowState = {
  liveNow: boolean
}

type LiveNowAction = {
  newLiveNow: boolean
}

const reducer = (_liveNowState: LiveNowState, { newLiveNow }: LiveNowAction): LiveNowState => ({
  liveNow: newLiveNow,
})

const LiveNowProvider = ({ children }: { children: React.ReactNode }) => {
  const [liveNowState, dispatch] = useReducer(reducer, { liveNow: false })

  const setLiveNow = (newLiveNow: boolean) => {
    dispatch({ newLiveNow })
  }

  return (
    <LiveNowContext.Provider
      value={{
        liveNow: liveNowState.liveNow,
        setLiveNow,
      }}
    >
      {children}
    </LiveNowContext.Provider>
  )
}

export default LiveNowProvider
